export default "__VITE_ASSET__wa2G3X2Z__"